import React, { useState } from 'react';
import { format } from 'date-fns';
import { Grid, IconButton } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';

const renderDate = (date: string) => {
  try {
    return date ?
      format(new Date(date), 'M/d/yyyy, hh:mm aaa') :
      '';
  } catch (e) {
    return '';
  }
}

export default function AuditTrailCell(
  {date, metadata, events, onAdd}: {date: string, metadata: any, events: number, onAdd: Function}
) {
  const [isShown, setIsShown] = useState(false);
  
  return (
    <Grid container justify="center" alignItems="center" spacing={2}
      style={{minHeight: 68, flexWrap: 'nowrap'}}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      <Grid item>
        {events > 1 ? (<span> ({events}) </span>) : null}
        {renderDate(date)}
        {
          metadata ?
            (<div>
              {Object.keys(metadata)
                .filter((key) => metadata[key] !== undefined)
                .map((key) => (<p key={key}>
                    {key}: {metadata[key] === null ? '' : metadata[key].toString()}
                  </p>)
                )}
            </div>) :
            null
        }
      </Grid>
      {
          isShown ? <Grid item>
            <IconButton aria-label="add" color="primary" onClick={() => onAdd()}>
              <AddCircle />
            </IconButton>
          </Grid> : null
        }
    </Grid>
  );
}